import React from "react";

const symbols = /[\r\n%#()<>?[\\\]^`{|}]/g;

export const unit = (size = 1) => `${1 * size}rem`;

export const encodeSVG = (data) =>
  data
    .replace(/'/g, '"')
    .replace(/>\s{1,}</g, "><")
    .replace(/\s{2,}/g, " ")
    .replace(symbols, encodeURIComponent);

export const clonePropsToChildren = (component, props) =>
  component
    ? React.Children.map(component, (child) => React.cloneElement(child, props))
    : null;

export const keysToObject = (acc, key) => ({ ...acc, [key]: key });

/**
 * Generates a secure random number
 * @returns number
 */
export const getRandomNumber = () => {
  const crypto = window.crypto || window.msCrypto;

  //INFO: Size of typed array is set to 1, so that only one random number can be generated.
  const typedArray = new Uint32Array(1);
  const generatedNumberArray = crypto.getRandomValues(typedArray);

  return generatedNumberArray?.[0];
};

export const randomValueBetween = (min, max) =>
  Math.floor(min + getRandomNumber() * (max + 1 - min));

//Calculate rem value from css variable
export const remValue = (cssVar, decPlaces) => {
  if (cssVar === "0rem") {
    return 0;
  }
  let power = parseInt(cssVar.split("var(--s")[1].slice(0, -1));
  return decPlaces
    ? parseFloat(Math.pow(1.5, power).toFixed(decPlaces))
    : Math.pow(1.5, power);
};

const lipsum =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec nec quam orci. Vivamus laoreet nunc luctus, egestas lacus consequat, euismod enim. Curabitur placerat at dolor a euismod. Quisque ut orci lorem. Phasellus sit amet ipsum id urna viverra feugiat eget vel nibh. Donec id erat orci. Nunc consequat lobortis libero, id gravida ante tincidunt in. Etiam id blandit sapien. Vestibulum molestie in tortor vitae dignissim. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Proin bibendum scelerisque suscipit. Ut id pretium nibh, at eleifend massa. Nunc tempus tellus sapien, eget suscipit sapien cursus ac. Quisque augue mauris, facilisis nec magna nec, molestie blandit odio. Curabitur a tortor elementum, aliquet massa sed, dignissim nibh. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae.  Sed tristique quam quis dictum tristique. Sed ut faucibus orci. Integer eu felis ligula. Quisque erat eros, porta ut semper vitae, volutpat in velit. Nunc ut dignissim purus. Phasellus et elementum arcu. Praesent eleifend felis vel cursus fringilla. Maecenas egestas, quam id tempor placerat, velit velit laoreet magna, volutpat ultrices augue metus eget nisl. Nullam justo lorem, tempus convallis sollicitudin nec, consectetur sit amet libero.  Integer pharetra justo quis mauris euismod, nec cursus mauris porta. Aliquam aliquet scelerisque elementum. Sed sit amet rutrum sem. Ut volutpat dui nunc, nec sagittis tortor volutpat sed. Nunc eu neque hendrerit, sollicitudin augue a, convallis magna. Nullam dapibus nibh tellus, eget blandit mauris aliquet ac. Sed lectus quam, aliquet vitae libero eu, fringilla malesuada augue. Quisque ut egestas augue, posuere tincidunt lacus. Quisque molestie at ligula sed fringilla. Pellentesque ultricies neque et urna placerat scelerisque.  Vivamus imperdiet lorem vitae tellus varius molestie. Mauris sed elit elementum, imperdiet enim at, ultricies magna. Nullam faucibus dictum diam, tempor luctus enim rutrum eget. Duis urna tellus, ullamcorper quis rhoncus ut, sodales eu mauris. Morbi sodales mattis dolor et hendrerit. Curabitur nunc nunc, dapibus sit amet orci sit amet, volutpat pulvinar ipsum. Sed vel enim tellus. Praesent urna erat, ullamcorper vel neque vitae, fermentum aliquet diam. Maecenas dictum arcu faucibus libero ornare auctor.  Quisque in pellentesque sem, at faucibus magna. Vivamus et accumsan purus. In rutrum ullamcorper leo, in lacinia neque imperdiet imperdiet. Sed ultrices nec leo at rhoncus. Integer vitae vulputate ex. Maecenas rutrum tellus elit, ut feugiat turpis vestibulum at. Pellentesque aliquam ut nisi sed vestibulum. Integer imperdiet, erat at ultricies porttitor, velit tortor efficitur augue, at aliquet augue nulla vel purus. Donec lobortis sodales rhoncus. Cras sodales scelerisque aliquet. Donec accumsan at tellus quis consequat. Mauris sed ex nec dolor elementum maximus non dictum augue.";

export const makeLipsum = (howManyCharacters) =>
  lipsum.slice(0, howManyCharacters);

export const callRedirectAPI = (instance, request, loginAPI = true) => {
  //INFO: expiring the msal.interaction.status cookie.
  document.cookie =
    "msal.interaction.status" + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  if (instance && loginAPI) {
    instance.loginRedirect(request);
  } else if (instance) {
    instance.logout(request);
  } else {
    //INFO: there is no instance, do nothing.
  }
};

export const convertDateToUTC = (date) => {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
};
